import { lighten, IconButton, Tooltip, Theme } from "@mui/material";
import { SxProps } from "@mui/system";
import { COLORS } from "../../../../../constants";

export interface ActionIconProps {
  active: boolean;
  action: () => void;
  tooltip?: string;
}

interface Props extends ActionIconProps {
  children: JSX.Element;
  sx?: SxProps;
}

const toolTipStyles = {
  ".MuiTooltip-popper": {
    ".MuiTooltip-tooltip": {
      "&.MuiTooltip-tooltipPlacementBottom": {
        marginTop: 0,
      },
    },
  },
};

const iconStyles = {
  color: (theme: Theme) => lighten(theme.palette.primary.main, 0.13),
  "&.Mui-disabled": {
    color: lighten(COLORS.BLACK, 0.7),
  },
};

/* istanbul ignore next */
const ActionIcon = ({
  active,
  action,
  children,
  tooltip = "",
  sx,
  ...rest
}: Props): JSX.Element => {
  return (
    <Tooltip title={tooltip} sx={toolTipStyles}>
      <span>
        <IconButton
          onClick={action}
          disabled={!active}
          size="small"
          sx={{
            ...iconStyles,
            ...sx,
          }}
          {...rest}
        >
          {children}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default ActionIcon;
